import React from 'react';
import { useHistory } from 'react-router-dom';
import './style.sass';
import { BtnWhats } from 'components/Buttons/BtnWhats'
import { BtnFloatMenu } from 'components/Buttons/floatMenu'
import { useToken } from 'pages/Header/Content/hooks/useToken';
import { BASE_PATH, BASE_PATH_PORTAL, SUB_DIRECTORY } from 'constants/general';

export default function HeaderMobileCredito(props) {
    const { 
        type,
        title,
        logo,
        btnTypeR,
        action,
        valToken = true,
        goBack
    } = props;

    const history = useHistory();
    const validaToken = useToken({firstActive: valToken, name: "header MobileCredito"})

    // type = back / close
    const regresar = () => {
        if(goBack === 'homeClaro'){
            window.location=`${BASE_PATH_PORTAL}`
        }
        else if(goBack === 'claroScore'){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}validacion-antes/0`);
        }
        else{
            history.goBack(-1);
        }
    };

    return (
        <>
            {type === "back" &&
                <div className="contentClose no-printme ">
                    <div className="btn close" onClick={regresar} ></div>
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : btnTypeR ===  "floatMenu"
                            ? <BtnFloatMenu />
                            : null
                    }
                </div>
            }
            {type === "backFull" &&
                <div className="contentClose fullContainer no-printme ">
                    <div className="btn close" onClick={regresar} ></div>
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : btnTypeR ===  "floatMenu"
                            ? <BtnFloatMenu />
                            : null
                    }
                </div>
            }
            {type === "backFullAction" &&
                <div className={title ? "contentClose fullContainer no-printme " : "contentCloseX no-printme " }>
                    {title &&
                        <div className="btn close" onClick={action} ></div>
                    }
                    <div className="title">
                        {title &&
                            <p >{title}</p>
                        }
                        {logo &&
                            <img src={logo} alt="logo-sears"></img>
                        }
                    </div>
                    {logo &&
                            
                        <div className="btn closeX" onClick={action} ></div>
                    }
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : null
                    }
                </div>
            }
            {type === "backPayment" &&
                <div className="contentClose no-printme ">
                    <div className="btn close" onClick={action} ></div>
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    {btnTypeR === "whats"
                        ? <BtnWhats />
                        : null
                    }
                </div>
            }
            

            {(type === "close" && title) &&
                <div className="contentCloseX no-printme ">
                    <div className="title">
                        <p >{title}</p>
                    </div>
                    <div className="btn closeX" onClick={regresar} ></div>
                </div>
            }

            {(type === "close" && logo) &&
                <div className="contentCloseX no-printme ">
                    <div className="title">
                        <img src={logo} alt="logo-sears"></img>
                    </div>
                    <div className="btn closeX" onClick={regresar} ></div>
                </div>
            }
        </>
    )
}